import React from 'react';
import styles from './BottomNav.module.css';

function BottomNav({
  visible = true,
  menuItems = [],
  activeKey,
  onMenuClick
}) {
  if (!visible) return null;

  const renderBadge = (badge) => {
    if (!badge) return null;

    // true: 只显示小红点
    if (badge === true) {
      return <span className={`${styles.badge} ${styles.dotBadge}`} />;
    }

    return <span className={styles.badge}>{badge}</span>;
  };

  return (
    <div className={styles.bottomNav}>
      {menuItems.map(item => {
        const isActive = activeKey === item.key;
        // 选中用 icon；未选中优先用 unselectedIcon，没有则回退到 icon
        const currentIcon = isActive
          ? item.icon
          : (item.unselectedIcon || item.icon);

        return (
          <div
            key={item.key}
            className={`${styles.bottomNavItem} ${isActive ? styles.active : ''}`}
            onClick={() => onMenuClick?.(item)}
          >
            <span className={styles.bottomNavIconWrapper}>
              <span className={styles.bottomNavIcon}>
                {currentIcon?.startsWith('#') ? (
                  <svg className={styles.bottomNavSvgIcon} aria-hidden="true">
                    <use xlinkHref={currentIcon}></use>
                  </svg>
                ) : (
                  currentIcon || '•'
                )}
              </span>
              {renderBadge(item.badge)}
            </span>

            <div className={styles.bottomNavLabel}>{item.label}</div>
          </div>
        );
      })}
    </div>
  );
}

export default BottomNav;